import { deleteTypeOptionArray } from "../generic";

export class DropWithoutFabricLiabilityRequestObject {
    constructor(remarks) {
        this.actionOperation = 'drop';
        this.status = 'dropped';
        this.object_status = 'dropped';
        this.object_status_no = 14;
        this.fabric_liability_status = deleteTypeOptionArray['without-fabric-liability'].fabricStatusOption;
        this.fabric_liability_remarks = remarks;
        this._api_resource_name = 'core-product';
        this._api_resource_action = 'drop-core-product';
    }

    buildDeleteProductRequestObject() {
        return {
            data: {
                actionOperation: this.actionOperation,
                status: this.status,
                object_status: this.object_status,
                object_status_no: this.object_status_no,
                fabric_liability_status: this.fabric_liability_status,
                fabric_liability_remarks: this.fabric_liability_remarks
            }
        }
    }


    buildDeleteProductURLString() {
        let urlString = "";
        if (this._api_resource_name) {
            urlString += this._api_resource_name + '/'
        }
        if (this._api_resource_action) {
            urlString += this._api_resource_action + '/'
        }

        return urlString;
    }

}